// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_containerFilter__2nbM- {
  background-color: white;
  padding: 12px;
  margin-bottom: 10px;
  box-shadow: 1px 1px 1px -1px rgba(164, 166, 163, 0.9803921569);
  border-radius: 5px;
}
.styles_containerFilter__2nbM- h3 {
  font-size: 16px;
}

.styles_containerTable__RvIWH {
  background-color: white;
  padding: 15px;
  box-shadow: 1px 1px 1px -1px rgba(164, 166, 163, 0.9803921569);
  border-radius: 5px;
}

.styles_section__3mgF7 {
  padding: 10px;
}

.styles_containerTop__1XOme {
  display: flex;
  padding-bottom: 10px;
}

.styles_wrapperRight__uy-LG {
  height: 60px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-left: 15px;
  font-size: 12px;
  gap: 1px;
}

.styles_wrapperLeft__PoGuP img {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  margin: 0 15px 0 8px;
}

.styles_name__Kr1qQ {
  font-weight: bold;
}

.styles_line__Re\\+Xd {
  border-bottom: 1px solid black;
  width: 100%;
  margin: 10px 0;
}

.styles_containerCenter__6cL6q {
  display: flex;
  justify-content: space-between;
  padding: 1px 12px;
}
.styles_containerCenter__6cL6q span {
  font-size: 18px;
  font-weight: bold;
}

.styles_wrapperBottom__JRbk3 {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 60px;
}

.styles_smallLine__0lh8q {
  width: 100%;
  margin: 0 auto;
  border-bottom: 1px solid black;
  width: 30%;
  padding-top: 100px;
}

.styles_containerBottom__TknfJ {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  gap: 10px;
  margin-bottom: 70px;
}

.styles_site__slbrC {
  width: 100%;
  display: flex;
  justify-content: left;
  padding-left: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/Components/Financeiro/ImprimirRecibos/Imprimir/styles.module.scss"],"names":[],"mappings":"AAAA;EACE,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,8DAAA;EACA,kBAAA;AACF;AACE;EACE,eAAA;AACJ;;AAGA;EACE,uBAAA;EACA,aAAA;EACA,8DAAA;EACA,kBAAA;AAAF;;AAGA;EACE,aAAA;AAAF;;AAGA;EACE,aAAA;EACA,oBAAA;AAAF;;AAGA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,iBAAA;EACA,eAAA;EACA,QAAA;AAAF;;AAIE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oBAAA;AADJ;;AAKA;EACE,iBAAA;AAFF;;AAKA;EACE,8BAAA;EACA,WAAA;EACA,cAAA;AAFF;;AAKA;EACE,aAAA;EACA,8BAAA;EACA,iBAAA;AAFF;AAIE;EACE,eAAA;EACA,iBAAA;AAFJ;;AAMA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AAHF;;AAMA;EACE,WAAA;EACA,cAAA;EACA,8BAAA;EACA,UAAA;EACA,kBAAA;AAHF;;AAMA;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;AAHF;;AAMA;EACE,WAAA;EACA,aAAA;EACA,qBAAA;EACA,kBAAA;AAHF","sourcesContent":[".containerFilter {\n  background-color: white;\n  padding: 12px;\n  margin-bottom: 10px;\n  box-shadow: 1px 1px 1px -1px #a4a6a3fa;\n  border-radius: 5px;\n\n  h3 {\n    font-size: 16px;\n  }\n}\n\n.containerTable {\n  background-color: white;\n  padding: 15px;\n  box-shadow: 1px 1px 1px -1px #a4a6a3fa;\n  border-radius: 5px;\n}\n\n.section {\n  padding: 10px;\n}\n\n.containerTop {\n  display: flex;\n  padding-bottom: 10px;\n}\n\n.wrapperRight {\n  height: 60px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  margin-left: 15px;\n  font-size: 12px;\n  gap: 1px;\n}\n\n.wrapperLeft {\n  img {\n    width: 60px;\n    height: 60px;\n    border-radius: 50%;\n    margin: 0 15px 0 8px;\n  }\n}\n\n.name {\n  font-weight: bold;\n}\n\n.line {\n  border-bottom: 1px solid black;\n  width: 100%;\n  margin: 10px 0;\n}\n\n.containerCenter {\n  display: flex;\n  justify-content: space-between;\n  padding: 1px 12px;\n\n  span {\n    font-size: 18px;\n    font-weight: bold;\n  }\n}\n\n.wrapperBottom {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 60px;\n}\n\n.smallLine {\n  width: 100%;\n  margin: 0 auto;\n  border-bottom: 1px solid black;\n  width: 30%;\n  padding-top: 100px;\n}\n\n.containerBottom {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  justify-content: center;\n  gap: 10px;\n  margin-bottom: 70px;\n}\n\n.site {\n  width: 100%;\n  display: flex;\n  justify-content: left;\n  padding-left: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"containerFilter": `styles_containerFilter__2nbM-`,
	"containerTable": `styles_containerTable__RvIWH`,
	"section": `styles_section__3mgF7`,
	"containerTop": `styles_containerTop__1XOme`,
	"wrapperRight": `styles_wrapperRight__uy-LG`,
	"wrapperLeft": `styles_wrapperLeft__PoGuP`,
	"name": `styles_name__Kr1qQ`,
	"line": `styles_line__Re+Xd`,
	"containerCenter": `styles_containerCenter__6cL6q`,
	"wrapperBottom": `styles_wrapperBottom__JRbk3`,
	"smallLine": `styles_smallLine__0lh8q`,
	"containerBottom": `styles_containerBottom__TknfJ`,
	"site": `styles_site__slbrC`
};
export default ___CSS_LOADER_EXPORT___;
